export const SET_USER_DATA = 'SET_USER_DATA';
export const CLEAR_USER_DATA = 'CLEAR_USER_DATA';
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const SET_USER_LOADING = 'SET_USER_LOADING';

export const setUserData = (userData) => ({
  type: SET_USER_DATA,
  payload: userData,
});

export const clearUserData = () => ({
  type: CLEAR_USER_DATA,
});

export const updateUserData = (userData) => ({
  type: UPDATE_USER_DATA,
  payload: userData,
});

export const setUserLoading = (loading) => ({
  type: SET_USER_LOADING,
  payload: loading,
});
